export const supportedLocales = [
    {
        title: "Suomi",
        img: require("@/assets/images/flags/fi.png"),
        locale: "fi",
    },
    {
        title: "Svenska",
        img: require("@/assets/images/flags/sv.png"),
        locale: "sv",
    },
    {
        title: "Norsk",
        img: require("@/assets/images/flags/no.png"),
        locale: "no",
    },
    {
        title: "English",
        img: require("@/assets/images/flags/en.png"),
        locale: "en",
    },
    {
        title: "Lietuvių",
        img: require("@/assets/images/flags/lt.png"),
        locale: "lt",
    },
    {
        title: "Español",
        img: require("@/assets/images/flags/es.png"),
        locale: "es",
    }
];